export const credit_statement_header_display = {
  balance_label: "Balance",
  as_of: "As of {date}",
  generated_at: "Generated {date}",
  dba_line: "DBA: {dba}",
  no_organization: "No organization on file.",
} as const;
